/* global SERVER_URL $ */
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Draggable from 'react-draggable';
import ReactTooltip from 'react-tooltip';
import { modal } from 'react-redux-modal';
import { Loader } from '../../../components';
import { generateSnapshotUrl } from '../../../utils';
import { postComment } from '../../../actions/comment';
import { createSnapshot, submitToContest} from '../../../actions/takeSnapshot';
import './styles.scss';
import LegacyTakeSnapshot from './LegacyTakeSnapshot';
import SuccessModal from '../SuccessModal';
import { eventGA, modalViewGA } from '../../../utils/googleAnalytics';
import { initializeGTMWithEvent } from '../../../utils/googleTagManager';
import Popout from '../../react-popout';

const STATE_READY = 'READY';
const STATE_COMMENTING = 'COMMENTING';
const STATE_SUCCESS = 'SUCCESS';

const propTypes = {
  currentItem: PropTypes.object,
  onSnapshotError: PropTypes.func.isRequired,
  onSnapshotReshoot: PropTypes.func.isRequired,
};

const defaultProps = {
  currentItem: {},
  onSnapshotError: () => {},
};

class TakeSnapshotModal extends React.Component {

  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.share = this.share.bind(this);
    this.shareLivecam = this.shareLivecam.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.closeSuccessMessage = this.closeSuccessMessage.bind(this);
    this.downloadSnapshot = this.downloadSnapshot.bind(this);
    this.postToComments = this.postToComments.bind(this);
    this.submitToContest = this.submitToContest.bind(this);
    this.setCurrentSnapshot = this.setCurrentSnapshot.bind(this);
    this.saveSelectedSnapshot = this.saveSelectedSnapshot.bind(this);
    this.setImagePopout = this.setImagePopout.bind(this);

    this.state = {
      caption: '',
      commentStatus: STATE_READY,
      count: 0,
      submittingToContest: false,
      currentSnapshot: '',
      lastSavedSnapshotId: null,
      imageUrl: null,
    };
  }

  componentDidMount() {
    modalViewGA('take-snapshot');
  }

  closeModal(e) {
    e.preventDefault();
    this.props.removeModal();
  }

  handleChange(event) {
    if ($(event.target).hasClass('error')) {
      $(event.target).removeClass('error').attr('placeholder', 'write a detailed description or comment about the photo');
    }
    this.setState({ caption: event.target.value });
  }

  closeSuccessMessage() {
    this.setState({ commentStatus: STATE_READY });
  }

  postToComments() {
    const { currentItem, remoteAuth, livecamId, newCommentSystem, pageUrl } = this.props;
    const { slug, stream_id, disqus_id: disqusId } = currentItem;
    let { caption } = this.state;
    const { commentStatus } = this.state;
    if (commentStatus === STATE_COMMENTING) return;
    const imageUrl = this.child.getWrappedInstance().captureSnapshot();
    const watermark = (stream_id) ? 0 : 1;

    if (!caption || caption === '' || caption === false || caption === ' ' || caption === 'Write a comment to submit your photo to the community comments...') {
      $('textarea#viewer-caption').addClass('error').attr('placeholder', 'Write a comment to submit your photo to the community comments...');
      return false;
    }

    this.setState({ commentStatus: STATE_COMMENTING });

    this.saveSelectedSnapshot(imageUrl, slug, caption, watermark)
      .then((response) => {
        const { image_url: snapshotUrl } = response;
        postComment(caption, disqusId, remoteAuth, snapshotUrl, livecamId, newCommentSystem, pageUrl, () => {
          this.setState({ commentStatus: STATE_SUCCESS, caption: '' });
          initializeGTMWithEvent({
            event: 'buttonclick',
            buttondata: {
              action: 'Posted a snapshot to comments',
              title: 'Comment',
            },
          });
          eventGA({
            category: 'engagement',
            action: 'Posted a snapshot to comments',
            label: `${document.location.protocol}//${document.location.hostname}${document.location.pathname}${document.location.search}`,
            value: 10,
          });
        }, (error) => {
          alert(`There was an error submitting your comment: ${error}`);
          this.setState({ commentStatus: STATE_READY });
        });
      });

    return null;
  }

  shareLivecam() {
    const { currentItem } = this.props;
    const left = (screen.width / 2) - (700 / 2);
    const top = (screen.height / 2) - (320 / 2);
    const windowReference = window.open('', '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=700, height=320, top='+top+', left='+left);
    const caption = currentItem.twitter_text ? currentItem.twitter_text : `Something amazing is happening on the ${currentItem.title} livecam on @exploreorg`;
    const livecamLink = `https://explore.org/livecams/${currentItem.primary_canonical_cam_group_slug}/${currentItem.slug}`;

    const tweetUrl = 'https://twitter.com/intent/tweet?url='+encodeURIComponent(livecamLink)
      +'&text='+encodeURI(caption);

    windowReference.location = tweetUrl;
  }

  share(method) {
    const { currentItem } = this.props;
    const { slug, stream_id } = currentItem;
    const { caption } = this.state;
    const imageUrl = this.child.getWrappedInstance().captureSnapshot();
    const watermark = (stream_id) ? 0 : 1;

    if (this[`${method}Share`]) {
      let windowReference = null;
      if (method === 'twitter') {
        const left = (screen.width / 2) - (700 / 2);
        const top = (screen.height / 2) - (320 / 2);
        windowReference = window.open('', '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=700, height=320, top='+top+', left='+left);
      } else if (method === 'facebook' || method === 'pinterest') {
        windowReference = window.open('', '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=700, height=320');
      }

      this[`${method}Share`](this.saveSelectedSnapshot(imageUrl, slug, caption, watermark), windowReference);
    }
  }

  generateFacebookPopupUrl(urlProperties) {
    return 'https://www.facebook.com/dialog/feed?&e&display=popup&app_id='+ FBAPI_KEY +
      '&name='+ encodeURIComponent(urlProperties.name)+
      '&caption='+ encodeURIComponent(urlProperties.caption)+
      '&description='+ encodeURIComponent(urlProperties.description)+
      '&picture='+ encodeURIComponent(urlProperties.picture)+
      '&link='+ encodeURIComponent(urlProperties.link);
  }

  genereatePinterestPopupUrl(urlProperties) {
    return 'https://www.pinterest.com/pin/create/button/?'+
      'url='+encodeURIComponent(urlProperties.link) +
      '&media='+encodeURIComponent(urlProperties.picture)
      +'&description='+encodeURIComponent(urlProperties.description)
  }

  facebookShare(request, window) {
    request.then(function(response) {
      let { caption } = this.state;
      var snapshotDashboardUrl = 'https://explore.org/snapshots?snapshot='+response.uuid;

      let urlProperties = {
        name: this.props.currentItem['title'],
        link: snapshotDashboardUrl,
        picture: response.image_url,
        caption: 'Check out this snapshot from explore.org',
        description: caption || this.props.currentItem['facebook_text']
      }
      window.location = this.generateFacebookPopupUrl(urlProperties);
    }.bind(this));
  }

  twitterShare(request, window) {
    request.then(function(response) {
      let { caption } = this.state;
      if (!caption) caption = this.props.currentItem.twitter_text;

      var snapshotDashboardUrl = 'https://explore.org/snapshots?snapshot='+response.uuid;

      var tweetUrl = 'https://twitter.com/intent/tweet?url='
        +encodeURIComponent(snapshotDashboardUrl)
        +'&text='+encodeURI(caption);

      var left = (screen.width / 2) - (700 / 2);
      var top = (screen.height / 2) - (320 / 2);
      window.location = tweetUrl;
    }.bind(this));
  }

  pinterestShare(request, window) {
    request.then(function(response) {
      let { caption } = this.state;
      var snapshotDashboardUrl = 'https://explore.org/snapshots?snapshot='+response.uuid;

      let urlProperties = {
        link: snapshotDashboardUrl,
        picture: response.image_url,
        description: caption || this.props.currentItem['facebook_text']
      }
      window.location = this.genereatePinterestPopupUrl(urlProperties);
    }.bind(this));
  }

  mailShare(request) {
    request.then(function(response) {
      var liveCamUrl = 'https://explore.org/livecams/'+this.props.currentItem['slug'];
      var snapshotDashboardUrl = 'https://explore.org/snapshots?snapshot='+response.uuid;
      window.location.href = "mailto:?subject=Snapshot%20from%20explore.org&body=Check%20out%20my%20snapshot%20from%20explore.org%3A%0A"+encodeURIComponent(snapshotDashboardUrl)+"%0A%0ATo%20watch%20the%20live%20cams%2C%20visit%3A%0A"+encodeURIComponent(liveCamUrl);
    }.bind(this));
  }

  snapshotFullUrl(template, timestamp) {
    return generateSnapshotUrl(template, timestamp, true);
  }

  downloadSnapshot(suppliedCallback) {
    const { currentItem } = this.props;
    const { slug, stream_id } = currentItem;
    const { caption } = this.state;
    const defaultCallback = () => {};
    const callback = suppliedCallback || defaultCallback;
    const imageUrl = this.child.getWrappedInstance().captureSnapshot();
    const watermark = (stream_id) ? 0 : 1;

    const img = new Image();
    img.onload = () => {
      this.saveSelectedSnapshot(imageUrl, slug, caption, watermark).then(({ image_url: imageUrl }) => {
        callback(imageUrl);
      });
    };
    img.onerror = () => {
      this.saveSelectedSnapshot(imageUrl, slug, caption, watermark).then((response) => {

      });
    };
    img.src = imageUrl;
  }

  submitToContest() {
    const { currentItem, contestSubmit } = this.props;
    const { slug, stream_id: streamId } = currentItem;
    const { caption, submittingToContest } = this.state;
    if (submittingToContest) return;
    this.setState({ submittingToContest: true });
    const imageUrl = this.child.getWrappedInstance().captureSnapshot();
    const watermark = (streamId) ? 0 : 1;
    const { contests } = currentItem;
    const activeContests = contests.filter((contest) => {
      return moment().isBefore(moment(contest.end_date));
    });

    const img = new Image();
    img.onload = () => {
      this.saveSelectedSnapshot(imageUrl, slug, caption, watermark).then(({ snapshot_id: snapshotId }) => {
        const contestIds = activeContests.map(contest => contest.id);
        contestSubmit(snapshotId, contestIds).then(() => {
          modal.add(SuccessModal, {
            title: '',
            size: 'medium', // large, medium or small,
            hideTitleBar: true,
            id: 'success',
            message: 'Your snapshot has been successfully submitted to the contest!',
          });
          this.setState({ submittingToContest: false });
        }).catch(() => this.setState({ submittingToContest: false }));
      });
    };
    img.src = imageUrl;
  }

  visitGallery(userName) {
    window.location = `/snapshots/users/${userName}`;
  }

  setCurrentSnapshot(currentSnapshot) {
    this.setState({ currentSnapshot });
  }

  saveSelectedSnapshot(imageUrl, slug, caption, watermark) {
    const { saveSnapshot } = this.props;
    return saveSnapshot(imageUrl, slug, caption, watermark).then((response) => {
      this.setState({ lastSavedSnapshotId: response.uuid });
      return response;
    });
  }

  setImagePopout(imageUrl) {
    this.setState({ imageUrl });
  }

  render() {
    const { currentItem, snapshotMap, onSnapshotReshoot } = this.props;
    const { caption, commentStatus, submittingToContest, currentSnapshot, lastSavedSnapshotId, imageUrl } = this.state;
    const { share, downloadSnapshot, visitGallery, handleChange, postToComments, shareLivecam, submitToContest } = this;
    const { contests } = currentItem;
    let hasContest = false;
    if (contests) {
      hasContest = _.some(contests, (contest) => {
        return moment().isBefore(moment(contest.end_date));
      });
    }
    const contestIconClass = submittingToContest ? 'fa-spin fa-spinner' : 'fa-trophy';
    return (
      <div>
        <Draggable handle=".handle">
        <div className="modals-popup takeSnapshot-modal bg-fff-50 handle" data-draggable>
          <div className="modal-header d-flex align-items-center">
            <div className="col">snapshot tool</div>
            <div className="text-right">
              <a className="closer" href="#" onClick={this.closeModal}></a>
            </div>
          </div>
          <LegacyTakeSnapshot
            ref={el => this.child = el}
            currentItem={currentItem}
            onSnapshotError={this.props.onSnapshotError}
            snapshotMap={snapshotMap}
            onSnapshotReshoot={onSnapshotReshoot}
            setCurrentSnapshot={this.setCurrentSnapshot}
          />

          <div className="info d-flex">
            {commentStatus === STATE_READY &&
              <textarea
                id="viewer-caption"
                className="form-control text-center u-textSize-20 u-font-foundation-light"
                value={caption}
                onChange={handleChange}
                placeholder="write a detailed description or comment about the photo"
              />
            }
            {commentStatus === STATE_COMMENTING &&
              <Loader style={{ height: 100 }} dark />
            }
            {commentStatus === STATE_SUCCESS &&
              <div id="success-dialog" className={(!commentStatus) ? 'hidden' : 'not-hidden'}>
                <div id="top">
                  <p>SUCCESS</p>
                </div>
                <div id="dialog-body">
                  <p>Please be patient your snapshot may take a few minutes to render into the comment thread.</p>
                </div>

                <div id="ok-button" className="btn btn-success" onClick={this.closeSuccessMessage}>
                  <span>OK</span>
                </div>
              </div>
            }
          </div>

          <div className="info d-flex justify-content-center">
            <ul className="align-items-center justify-content-between list-style-none m-0 no-gutters pY-10 px-4 row w-100">
              <li className="col-auto">
                <Link data-tip data-for="post-comment" className="snapshot-action circle post-comment" onClick={postToComments}>
                  <i className="comments-icon"></i>
                </Link>
                <ReactTooltip id="post-comment" type="light" effect="solid">send to comments</ReactTooltip>
              </li>
              <li className="col-auto">
              <a href={currentSnapshot} target="_blank" data-tip data-for="download" className="snapshot-action circle download" onClick={downloadSnapshot}>
                <i className="download-icon"></i>
              </a>
              <ReactTooltip id="download" type="light" effect="solid">save and download</ReactTooltip>
              </li>
              <li className="col-auto">
                <a
                  data-tip
                  data-for="save"
                  className={`snapshot-action circle download contest-button text-center`}
                  onClick={() => downloadSnapshot(this.setImagePopout)}
                  style={{ width: 67, height: 67 }}
                >
                  <i className="fa fa-save"></i>
                </a>
                <ReactTooltip id="save" type="light" effect="solid">save to gallery</ReactTooltip>
                {!!imageUrl && (
                  <Popout title='Snapshot' onClosing={() => this.setState({ imageUrl: null })}>
                    <div><img src={imageUrl} style={{ width: '100%', height: 'auto' }} /></div>
                  </Popout>
                )}
              </li>
              {hasContest && (
                <li className="col-auto">
                  <Link data-tip data-for="contest" className="snapshot-action circle download contest-button" onClick={submitToContest}>
                    <i className={`fa ${contestIconClass}`}></i>
                  </Link>
                  <ReactTooltip id="contest" type="light" effect="solid">submit to contest</ReactTooltip>
                </li>
              )}
              <li className="col-auto">
                <Link data-tip data-for="gallery" className="snapshot-action circle visit-gallery" onClick={(e)=>{visitGallery(this.props.userName, e)}}>
                  <i className="gallery-icon"></i>
                </Link>
                <ReactTooltip id="gallery" type="light" effect="solid" multiline>gallery</ReactTooltip>
              </li>
            </ul>
          </div>
          {currentItem.survey_url && ((currentItem.require_snapshot_for_survey && lastSavedSnapshotId) || !currentItem.require_snapshot_for_survey) && (
            <div className="text-center">
              {currentItem.require_snapshot_for_survey && lastSavedSnapshotId && (
                <div className="text-center px-2 pt-2 pb-0">
                   Thanks for taking a snapshot! If you&apos;d like to help out this partner and take a survey, click the button below!
                </div>
              )}
              <Link
                to={`${currentItem.survey_url}?snid=${lastSavedSnapshotId}`}
                target="_blank"
                className="btn video-player-btn inverse-btn community-science-btn d-inline-block text-btn u-font-foundation-roman text-uppercase"
              >
                Community Science Survey
              </Link>
            </div>
          )}
          <div className="info d-flex justify-content-center align-items-center">
            <ul className="d-flex justify-content-space align-items-center list-style-none p-0 mT-10 mb-20">
              <li><div className="snapshot-divider" /></li>
              <li><span className="text-uppercase u-font-foundation-light u-textSize-16 pX-15 social-share-text">Social Share</span></li>
              <li><div className="snapshot-divider" /></li>
            </ul>
          </div>

          <div className="info d-flex justify-content-center">
            <ul className="d-flex justify-content-space align-items-center list-style-none p-0 snapshot-social-share">
              <li>
                <Link data-tip data-for="facebook" className="social-share-snapshot facebook snapshot-action" onClick={e => share('facebook', e)}>
                  <i className="facebook-icon" />
                </Link>
                <ReactTooltip id="facebook" type="light" effect="solid">share on facebook</ReactTooltip>
              </li>
              <li>
                <Link data-tip data-for="twitter" className="social-share-snapshot twitter snapshot-action" onClick={e => share('twitter', e)}>
                  <i className="twitter-icon" />
                </Link>
                <ReactTooltip id="twitter" type="light" effect="solid">tweet on twitter</ReactTooltip>
              </li>
              <li>
                <Link data-tip data-for="pinterest" className="social-share-snapshot pinterest snapshot-action" onClick={e => share('pinterest', e)}>
                  <i className="st_pinterest_custom" />
                </Link>
                <ReactTooltip id="pinterest" type="light" effect="solid">pin to pinterest</ReactTooltip>
              </li>
              <li>
                <Link data-tip data-for="mail" className="social-share-snapshot mail snapshot-action" onClick={e => share('mail', e)}>
                  <i className="mail-icon" />
                </Link>
                <ReactTooltip id="mail" type="light" effect="solid">email friend</ReactTooltip>
              </li>
            </ul>
          </div>
          <div className="text-center">
            <Link className="btn btn-twitter btn-sm mb-3" onClick={shareLivecam}>
              <i className="fa-twitter fab" /> Tweet out Livecam
            </Link>
          </div>
        </div>
        </Draggable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { timeline, timestampIndex, snapshotMap } = state.takeSnapshot;

  return {
    userName: state.auth.userName,
    timeline,
    timestampIndex,
    currentTimestamp: timeline[timestampIndex],
    snapshotMap,
    remoteAuth: state.auth.disqus_sso,
    livecamId: state.currentItem.data.id,
    newCommentSystem: state.currentItem.data.newCommentSystem,
    pageUrl: state.currentItem.data.canonical_url,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveSnapshot: (imageUrl, slug, caption, watermark) => dispatch(createSnapshot(imageUrl, slug, caption, watermark)),
    contestSubmit: (snapshotId, contestIds) => dispatch(submitToContest(snapshotId, contestIds)),
  };
}

TakeSnapshotModal.propTypes = propTypes;
TakeSnapshotModal.defaultProps = defaultProps;

export default connect(mapStateToProps, mapDispatchToProps)(TakeSnapshotModal);
